import template from './prems-premium-item-info-banner.html.twig';

const { Component } = Shopware;

const componentName = 'prems-premium-item-info-banner';
const componentRegistry = Component.getComponentRegistry();

if (!componentRegistry.has(componentName)) {
    Component.register(componentName, {
        template,

        props: [
            'pluginName'
        ],

        created() {
            const initContainer = Shopware.Application.getContainer('init');
            const bannerContainer = componentName;
            let isoLang = Shopware.Store.get('session').currentLocale.slice(0, 2);

            initContainer.httpClient.get(
                'https://premsoft.de/sw6-plugin-support-box/' + isoLang + '/' + this.pluginName + '/json'
            )
                .then(response => {
                    document.getElementById(bannerContainer).innerHTML = response.data;
                })
                .catch(error => {
                    document.getElementById(bannerContainer).closest('.sw-card-wrapper').style.display = 'none';
                });
        }
    });
}